module.exports = __webpack_public_path__ + "toBride1-we-y-g.6c062c05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride1-we-y-g.jpg
// module id = Shp2
// module chunks = 0